/**
 * mapCamera — última posición de cámara compartida entre las dos vistas.
 *
 * Cuando el usuario navega y luego cambia de vista (botón "Vista realista"
 * ↔ "Vista operativa"), la nueva vista se monta en la misma posición en
 * lugar de saltar al default. Las dos vistas hablan WGS84 para `center`,
 * grados para `bearing/pitch` y el `zoom` viene normalizado al estilo
 * MapLibre (logarítmico) — la vista realista convierte a `range` (metros)
 * con `zoomToRange()` al aplicar.
 *
 * Vida del store: en memoria. No persistimos entre sesiones a propósito —
 * un dashboard que arranca en una posición arbitraria de la sesión
 * anterior es más confuso que útil. Si se quisiera, basta con envolver
 * en `persist` middleware.
 *
 * El componente que monta una vista debe capturar el snapshot del store
 * con `useRef(useMapCamera.getState())` en lugar de subscribirse — así
 * los cambios posteriores (causados por la propia interacción de cámara)
 * no fuerzan re-renders que reseteen la cámara al valor del store.
 */
import { create } from 'zustand';

interface MapCameraState {
  center: [number, number] | null;
  zoom: number | null;
  bearing: number | null;
  pitch: number | null;
  setView: (
    center: [number, number],
    zoom: number,
    bearing: number,
    pitch: number,
  ) => void;
}

export const useMapCamera = create<MapCameraState>((set) => ({
  center: null,
  zoom: null,
  bearing: null,
  pitch: null,
  setView: (center, zoom, bearing, pitch) => set({ center, zoom, bearing, pitch }),
}));
